import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import getQuery from '../../helpers/api/get-query'
import Order from '../../types/api/order'
import Strapi, { EndpointQueryParameters, StrapiCreate, StrapiSingle, StrapiUpdate } from '../../types/strapi/strapi'

export const ordersApi = createApi({
    reducerPath: 'ordersApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['Orders'],
    endpoints: builder => ({
        getOrders: builder.query<Strapi<Order>, EndpointQueryParameters | void>({
            query: getQuery('/orders'),
            providesTags: ['Orders'],
        }),
        getMyOrders: builder.query<Strapi<Order>, EndpointQueryParameters | void>({
            query: getQuery('/orders/my'),
            providesTags: ['Orders'],
        }),
        getOrderByDocId: builder.query<
            StrapiSingle<Order>,
            [string, EndpointQueryParameters | void]
        >({
            query: ([docId, params]) => getQuery(`/orders/${docId}`)(params),
            providesTags: ['Orders'],
        }),
        createOrder: builder.mutation<StrapiSingle<Order>, StrapiCreate<Order>>({
            query: body => ({
                url: '/orders',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Orders'],
        }),
        updateOrder: builder.mutation<StrapiSingle<Order>, StrapiUpdate<Order>>({
            query: ({ docId, body, queryParams }) => ({
                url: getQuery(`/orders/${docId}`)(queryParams),
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Orders'],
        }),
    }),
})

export const {
    useGetMyOrdersQuery,
    useLazyGetMyOrdersQuery,
    useLazyGetOrdersQuery,
    useGetOrderByDocIdQuery,
    useCreateOrderMutation,
    useUpdateOrderMutation,
} = ordersApi
